import { render, staticRenderFns } from "./CreateTRDA.vue?vue&type=template&id=19035aab&scoped=true&"
import script from "./CreateTRDA.vue?vue&type=script&lang=ts&"
export * from "./CreateTRDA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19035aab",
  null
  
)

export default component.exports